import actions from "./actions";
import mutations from "./mutation";
export default {
  namespaced: true,
  state: {
    allFeedbackAssignedToMe: [],
    allFeedbackAppliedToMe: [],
    tableLoading: false,
    selectedRow: null,
  },
  actions,
  mutations,
};
